export const STATUSES = ["New", "Contacted", "Funded", "Declined"];

export const statusStyle = {
  New: "bg-[#DFFF00] text-[#052F24]",
  Contacted: "bg-[#052F24]/10 text-[#052F24]",
  Funded: "bg-[#052F24] text-[#DFFF00]",
  Declined: "bg-red-100 text-red-600",
};
